<div class="time-range-label">
  <div class="label">Selected time range:</div>
  <div class="time-range-time">{{timeFrom}} - {{timeTo}}</div>
</div>
